import { QuestionV3ControlTypes } from './enum';
import { QuestionBaseV3 } from './question-base';

export class SignaturePadV3 extends QuestionBaseV3 {
  controlType = QuestionV3ControlTypes.SIGNATURE_PAD;

  constructor(options: any = {}) {
    super(options);
  }
}
